import { debugExtendedAccess } from '../debug'

/**
 * Returns true if the URL contains valid Google Article Access (GAA) params.
 * TODO: Link to a public document describing GAA params.
 */
export function isGoogleExtendedAccess(
    params: Record<string, string | undefined> = getQueryParams(),
    referrerUrl: string = (typeof document !== 'undefined' &&
        document.referrer) ||
        '',
): boolean {
    // Validate GAA params.
    if (!params.gaa_at) {
        return false
    }
    if (!params.gaa_n) {
        console.error('SwG Entitlements: The `gaa_n` URL param is missing.')
        return false
    }
    if (!params.gaa_sig) {
        console.error('SwG Entitlements: The `gaa_sig` URL param is missing.')
        return false
    }
    if (!params.gaa_ts) {
        console.error('SwG Entitlements: The `gaa_ts` URL param is missing.')
        return false
    }
    if (parseInt(params.gaa_ts, 16) < Date.now() / 1000) {
        console.error(
            'SwG Entitlements: The `gaa_ts` URL param should ' +
                'contain a hex string timestamp which points to the future.',
        )
        return false
    }

    // Validate referrer.
    // NOTE: This regex was copied from SwG's AMP extension. https://github.com/ampproject/amphtml/blob/c23bf281f817a2ee5df73f6fd45e9f4b71bb68b6/extensions/amp-subscriptions-google/0.1/amp-subscriptions-google.js#L56
    const GOOGLE_DOMAIN_RE = /(^|\.)google\.(com?|[a-z]{2}|com?\.[a-z]{2}|cat)$/
    const domainMatch = /(^https?):\/\/([^/]+)($|\/)/
    const referrer = referrerUrl && referrerUrl.match(domainMatch)
    if (
        !referrer ||
        referrer[1] !== 'https' ||
        !GOOGLE_DOMAIN_RE.test(referrer[2])
    ) {
        // Real publications should bail if this referrer check fails.
        // This script is only logging a warning for metering demo purposes.
        debugExtendedAccess(
            `SwG Entitlements: This page's referrer ("${
                referrer ? referrer[0] : 'undefined'
            }") can't ` +
                'grant Google Article Access. Real publications should bail if this ' +
                'referrer check fails.',
        )
        if (process.env.ENVIRONMENT === 'prd') {
            return false
        }
    }

    return true
}

/**
 * Returns query params from URL.
 */
function getQueryParams(): Record<string, string> {
    const queryParams: Record<string, string> = {}
    location.search
        .substring(1)
        .split('&')
        .forEach((pair) => {
            const parts = pair.split('=')
            queryParams[parts[0]] = parts[1]
        })
    return queryParams
}
